import { ApiReducer as api } from 'reactifi';
import { routerReducer as routing } from 'react-router-redux';

export default { api, routing };